import { render, staticRenderFns } from "./ChartAvgSalesTotal.vue?vue&type=template&id=78eb1eb9&"
import script from "./ChartAvgSalesTotal.vue?vue&type=script&lang=js&"
export * from "./ChartAvgSalesTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports